import { Injectable } from '@angular/core';
import { CustomFields } from '../../overview/models/shipment';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Container } from '../../overview/models/container';

interface CustomFieldKeys {
  containerNo: string;
  masterNo: string;
  customerNo: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContainerDetailsService {
  constructor(private http: HttpClient) {}

  getContainerBy(id: string, isArchived: boolean) {
    const url = isArchived ? 'archive/containers' : 'containers';
    return this.http.get<Container>(`${environment.apiUrl}/${url}/${id}`);
  }

  updateCustomFields(keys: CustomFieldKeys, data: CustomFields) {
    return this.http.put(`${environment.apiUrl}/containers/customFields`, {
      keys: [keys],
      data
    });
  }
}
